import React from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

export const formInitialValues = {
  amount: null,
};

export const amountValidationRule = Yup.number()
  .nullable()
  .typeError(
    <FormattedMessage
      id="onboarding_deposit_investor_amount_bad_value"
      defaultMessage={dlt['"onboarding_deposit_investor_amount_bad_value']}
    />
  )
  .min(
    100,
    <FormattedMessage
      id="onboarding_aml_form_min_value"
      defaultMessage={dlt['onboarding_aml_form_min_value']}
      values={{ value: 100, currency: ' €' }}
    />
  );

export default Yup.object().shape({
  amount: amountValidationRule,
});
